<template>
    <div>

        <div class="show-navigation">
            <div class="container mt--md">
                <div class="profile profile--horizontal mb--md">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img">
                            <img v-bind:src="user.avatar" alt=""/>
                        </span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">{{ user.nick }}</div>
                        <div class="profile__level"><span class="badge badge--primary">Level {{ user.level }}</span> / {{ user.xp_points }} XP</div>
                    </div>

                    <router-link to="/store" class="panel bg--layer-dark panel--btn ml--auto">
                        <div class="coin">
                            <img src="/img/icons/coin.png" alt=""/>
                            <span>{{ user.balance }}</span>
                        </div>
                        <span class="inner-btn inner-btn--xs inner-btn--circle inner-btn--success ml--sm">+</span>
                    </router-link>
                </div>

                <div class="row">
                    <div class="col-4 mb--md">
                        <router-link :to="{ name: 'achievementGroups'}" class="btn btn--block btn--white btn--top-icon">
                            <svg class="icon">
                                <use xlink:href="/img/icon-sprite.svg#achievement"></use>
                            </svg>
                            Achievements
                        </router-link>
                    </div>

                    <div class="col-4 mb--md">
                        <router-link :to="{ name: 'newsList'}" class="btn btn--block btn--white btn--top-icon">
                            <svg class="icon">
                                <use xlink:href="/img/icon-sprite.svg#flash"></use>
                            </svg>
                            News feed
                        </router-link>
                    </div>

                    <div class="col-4 mb--md">
                        <router-link to="/statistics" class="btn btn--block btn--white btn--top-icon">
                            <svg class="icon">
                                <use xlink:href="/img/icon-sprite.svg#statistic"></use>
                            </svg>
                            Statistics
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="bg--layer-dark pt--md pb--20 mb--lg">
                <h2 class="title-primary text--center"><span class="c--gradient-primary">Featured tournaments</span>
                </h2>

                <div class="swiper-container tournament-carousel">
                    <div class="swiper-wrapper">
                        <div v-for="tournament in tournaments" class="swiper-slide">
                            <router-link :to="'/tournament/' + tournament.id" class="tournament-box" :style="'background-image: url(' + tournament.image + ');'">
                                <img class="tournament-box__bg" :src="tournament.image" alt="" />

                                <div v-if="! tournament.entry_fee" class="tournament-box__tags">Free to enter</div>

                                <div class="tournament-box__content">
                                    <h4 class="tournament-box__title">{{ tournament.name }}</h4>
                                    <time :datetime="tournament.start_date">{{ tournament.start_date }} (CET)</time>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <p class="text--center text--uppercase opacity--md">Get power ups</p>

                <div class="row">
                    <div class="col-6 mb--md" v-for="powerUp in powerUps">
                        <button @click="addPowerUp(powerUp)" class="btn btn--block btn--white btn--left-icon-circle">
                            <div class="btn-icon" :class="powerUp.iconClass">
                                <svg class="icon">
                                    <use :xlink:href="powerUp.image"></use>
                                </svg>
                            </div>

                            <div>
                                {{ powerUp.name }} ({{ userPowerUps(powerUp.id) }})
                                <div class="coin coin--xs">
                                    <img src="img/icons/coin.png" alt=""/> <span>{{ powerUp.quid }}</span>
                                </div>
                            </div>

                            <span class="inner-btn inner-btn--xs inner-btn--circle inner-btn--success ml--auto">+</span>
                        </button>
                    </div>
                </div>

                <router-link to="/new-game" class="btn btn--block btn--primary mb--lg">Start new game</router-link>
            </div>
        </div>

        <navigation></navigation>

        <modal show="false" type="error" ref="errorModal">
            <template v-slot:message>
                <div v-if="errors.any()">
                    <div v-for="error in errors.all()">{{ error }}</div>
                </div>
            </template>

            <template v-slot:title>
                Error
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Swiper from "swiper";

import Navigation from '../partial/Navigation'
import Errors from "../../util/Errors";
import api from "../../api/store";
import tournamentsApi from "../../api/tournaments";

export default {
    name: "DashboardAuthorized",
    components: {
        Navigation,
    },
    data: () => ({
        swiper: null,
        errors: new Errors(),
        tournaments: [],
        powerUps: null
    }),

    methods: {
        addPowerUp(powerUp) {
            axios.post('/add-power-up', {id: powerUp.id})
                .then(() => this.$store.dispatch('auth/loadUserPowerUps'))
                .catch((error) => {
                    if (error.response.status === 422) {
                        this.errors.record(error.response.data.errors)
                        this.$refs.errorModal.open()
                    }
                })
        },

        async loadTournamentsaments() {
            try {
                const response = await tournamentsApi.featuredTournaments()
                this.tournaments = response.data.data
            } catch (error) {

            }
        },

        userPowerUps(id) {
            return get(collect(this.user.power_ups).filter((item) => item.id == id).first(), 'quantity', 0)
        },

        isDisabled(powerUp) {
            return this.user.balance < powerUp.quid
        },

        loadPowerUps() {
            api.powerUps()
                .then((response) => {
                    this.powerUps = response.data.data
                })
        }
    },

    computed: {
        ...mapGetters('auth', [
            'user',
            'isLoggedIn'
        ]),
    },

    created() {
        this.$store.dispatch('auth/loadUserPowerUps')

        this.loadTournamentsaments()

        if (!this.swiper) {
            $(document).ready(() => {
                this.swiper = new Swiper('.tournament-carousel', {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                });
            })
        }

        this.loadPowerUps()
    }
}
</script>
